import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { updateUserPhoto } from '../redux/userSlice';

const EditPhoto = ({ image, id, ownerId, camera, aperture, shutter_speed, iso, lens, location, time, category, weather, notes, handleUpdatePhoto }) => {

        const user = useSelector((state) => state.user.user)
        const dispatch = useDispatch();

        const [newImage, setNewImage] = useState(image)
        const [newCamera, setNewCamera] = useState(camera)
        const [newAperture, setNewAperture] = useState(aperture)
        const [newShutter_speed, setNewShutter_speed] = useState(shutter_speed)
        const [newIso, setNewIso] = useState(iso)
        const [newLens, setNewLens] = useState(lens)
        const [newLocation, setNewLocation] = useState(location)
        const [newTime, setNewTime] = useState(time)
        const [newCategory, setNewCategory] = useState(category)
        const [newWeather, setNewWeather] = useState(weather)
        const [newNotes, setNewNotes] = useState(notes)

        const handleSubmit = (event) => {
            event.preventDefault();
            const formData = {
                ownerId: parseInt(user.id),
                image: newImage,
                camera: newCamera,
                aperture: newAperture,
                shutter_speed: newShutter_speed,
                iso: newIso,
                lens: newLens,
                location: newLocation,
                time: newTime,
                category: newCategory,
                weather: newWeather,
                notes: newNotes,
            };
            
            fetch(`https://fotoset.herokuapp.com/photos/${id}`, {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
            .then((r) => r.json())
            .then(data => {
                dispatch(updateUserPhoto(data))
            });
          }    

        return (
           
            <div className="photo-form">
                      <h3>Edit Photo Info</h3>
                      <form id="new-photo-form" onSubmit={handleSubmit}>
                <label className="label-name">Image Url: </label>
                <br/>
                <input type="text" id="image" className="input-box" accept="image/*" placeholder="Photo url..."onChange={(e) => setNewImage(e.target.value)}/>
                <br/>
                {/* <div className="previewProfilePic">
                    <img className="playerProfilePic_home_tile" src={imgData} alt="preview"/>
                </div> */}
                <label className="label-name">Camera Name: </label>
                <br/>
                <input type="text" className="input-box" name="camera" placeholder="Camera name..." value={newCamera} onChange={(e) => setNewCamera(e.target.value)}/>
                <br/>
                <label className="label-name">Aperture: </label>
                <br/>
                <input type="text" className="input-box" name="aperture" placeholder="Aperture..." value={newAperture} onChange={(e) => setNewAperture(e.target.value)}/>
                <br/>
                <label className="label-name">Shutter Speed: </label>
                <br/>
                <input type="text" className="input-box" name="shutter_speed" placeholder="Shutter Speed..." value={newShutter_speed} onChange={(e) => setNewShutter_speed(e.target.value)}/>
                <br/>
                <label className="label-name">ISO: </label>
                <br/>
                <input type="text" className="input-box" name="iso" placeholder="ISO..." value={newIso} onChange={(e) => setNewIso(e.target.value)}/>
                <br/>
                <label className="label-name">Camera Lens: </label>
                <br/>
                <input type="text" className="input-box" name="lens" placeholder="Camera lens..." value={newLens} onChange={(e) => setNewLens(e.target.value)}/>
                <br/>
                <label className="label-name">Location: </label>
                <br/>
                <input type="text" className="input-box" name="location" placeholder="Location..." value={newLocation} onChange={(e) => setNewLocation(e.target.value)}/>
                <br/>
                <label className="label-name">Date/Time: </label>
                <br/>
                <input type="text" className="input-box" name="time" placeholder="Time..." value={newTime} onChange={(e) => setNewTime(e.target.value)}/>
                {/* <input type="text" name="category" placeholder="category" value={category} /> */}
                <br/>
                <label className="label-name">Category: </label>
                <br/>
                <select className="input-box" name="category" id="category" form="new-photo-form" value={newCategory} onChange={(e) => setNewCategory(e.target.value)} required>
                            <option value="">Choose a category</option>
                            <option value="Cityscape">Cityscape</option>
                            <option value="Landscape">Landscape</option>
                            <option value="Street">Street</option>
                            <option value="Aerial">Nature</option>
                            <option value="Sport">Sport</option>
                            <option value="Portrait">Portrait</option>
                            <option value="Wildlife">Wildlife</option>
                            <option value="Food">Food</option>
                            <option value="others">Others</option>
                </select>
                <br/>
                <label className="label-name">Weather: </label>
                <br/>
                <input type="text" className="input-box" name="weather" placeholder="Weather..." value={newWeather} onChange={(e) => setNewWeather(e.target.value)}/>
                <br/>
                <label className="label-name">Notes: </label>
                <br/>
                <textarea type="text" className="input-area" name="notes" placeholder="Notes..." value={newNotes} onChange={(e) => setNewNotes(e.target.value)}/>
                <button type="submit" className="add-photo-btn">Update</button>
                <br/>
            </form>
          </div> 
        )
}

export default EditPhoto;